<div class="conteneur" *ngIf="preinscriptions && config; else loader">
  <div class="fx-direction-col">

    @if(config.infoMessage){
    <mat-card appearance="outlined" style="margin: 5px;" [portailCustomStyle]="config.styleCardInfo">
      <div [innerHtml]="config.infoMessage | safe"></div>
    </mat-card>
    }

    <mat-card appearance="raised" *ngFor="let preinsc of preinscriptions" class="card">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <mat-icon style="margin-right: 5px;">person</mat-icon>
          <span>{{ preinsc.nom }} {{ preinsc.prenom }}</span>
        </mat-card-title>
        <mat-card-subtitle class="fx-direction-row fx-start-center" style="margin-left: 5px;">
          <span *ngIf="preinsc.dateDeNaissance !== '0000-00-00'">Né le :
            {{preinsc.dateDeNaissance | date:'shortDate'}}</span>
          <span *ngIf="preinsc.dateAccouchement !== '0000-00-00'">Naissance prévue le :
            {{preinsc.dateAccouchement | date:'shortDate'}}</span>
        </mat-card-subtitle>
        <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </mat-card-header>
      <mat-menu #menu="matMenu" xPosition="before">
        <button *ngFor="let formPart of formParts" mat-menu-item
          (click)="openForm(preinsc.idPreInscription, formPart.stepName)">
          <mat-icon color="primary">
            {{ readOnly || (preinsc.decision !== 'En attente' && preinsc.decision !== '') ? 'visibility' : 'edit' }}
          </mat-icon>
          {{ formPart.label }}
        </button>
      </mat-menu>
      <mat-card-content class="card-content">

        <app-status-bar [decision]="preinsc.decision" [motifRefus]="preinsc.motifRefus"
          [motifAbandon]="preinsc.motifAbandon" />

        <!-- Main info section -->
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Date de la demande</span>
            <span class="info-value">{{ preinsc.dateDemande|date:'shortDate' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">Période d'inscription</span>
            <span class="info-value">
              <ng-container *ngIf="preinsc.souhaitDateDebut && preinsc.souhaitDateDebut !== '0000-00-00'">
                <span *ngIf="preinsc.souhaitDateFin && preinsc.souhaitDateFin !== '0000-00-00'; else fromDate">
                  du {{ preinsc.souhaitDateDebut|date:'shortDate' }} au {{ preinsc.souhaitDateFin|date:'shortDate' }}
                </span>
                <ng-template #fromDate>
                  à partir du {{ preinsc.souhaitDateDebut|date:'shortDate' }}
                </ng-template>
              </ng-container>
            </span>
          </div>

          @if(preinsc.decision === "Acceptée"){
          <div class="info-item full-width">
            <span class="info-label">Établissement</span>
            <span class="info-value">{{preinsc.etablissementRetenu}}</span>
          </div>
          }@else {
          <div class="info-item full-width">
            <span class="info-label">Souhait(s)</span>
            <div class="souhaits-list">
              <div class="souhait-item" *ngFor="let souhait of preinsc._Souhaits; let i = index">
                <span class="souhait-numero">{{i + 1}}</span>
                <span class="souhait-content">
                  {{souhait._Etablissement.designation}} ({{souhait._Accueil.designation}})
                </span>
              </div>
            </div>
          </div>
          }

          @if(preinsc.programmation.length){
          <div class="info-item full-width">
            <span class="info-label">Jours/horaires</span>
            <div class="horaires-grid">
              @for (entry of preinsc.programmation; track entry[0]) {
              @let key = entry[0];
              @let semaine = entry[1];
              <div class="semaine-block">
                <div class="semaine-titre" *ngIf="preinsc.programmation.length > 1">{{ key }}</div>
                <div class="jours-list">
                  @for (jour of semaine; track jour) {
                  <div class="jour-item">
                    <span class="jour-nom">{{jour.jour | titlecase}}</span>
                    <div class="horaires-list">
                      @if(jour.plage1Deb){
                      <span class="plage-horaire">{{jour.plage1Deb.substring(0, 5)}} - {{jour.plage1Fin.substring(0,
                        5)}}</span>
                      }
                      @if(jour.plage2Deb){
                      <span class="plage-horaire">{{jour.plage2Deb.substring(0, 5)}} - {{jour.plage2Fin.substring(0,
                        5)}}</span>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </mat-card-content>
      @if(config.enabledConfirmation && (preinsc.decision === "" || preinsc.decision ==='En attente')){
      <mat-card-actions align="end">
        @if(!preinsc.dateConfirmation){
        <button color="primary" mat-raised-button (click)="onConfirmButton(preinsc)" [disabled]="preinsc._isLoaded">

          <div class="fx-direction-row fx-align-item-center fx-gap-5">
            @if (preinsc._isLoaded) {
            <mat-progress-spinner mode="indeterminate" strokeWidth="2" diameter="18"
              color="accent"></mat-progress-spinner>
            }
            <span>{{'mikado.preinscriptions.text_confirmation_button' | trans}}</span>
          </div>

        </button>
        }@else {
        <i>Confirmée le <span style="font-weight: 500;">{{preinsc.dateConfirmation | date:'shortDate'}}</span></i>
        }

      </mat-card-actions>
      }
    </mat-card>

    <mat-card appearance="outlined" *ngIf="permToCreate" class="card card-add">
      <mat-card-header class="fx-direction-row fx-center-center">
        <mat-card-title class="fx-direction-row fx-center-center">
          Nouvelle préinscription
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="fx-direction-row fx-center-center" style="padding: 16px;">
        <button mat-fab color="primary" matTooltip="Nouvelle pré-inscription" [disabled]="!addBtnUrl"
          [routerLink]="addBtnUrl">
          <mat-icon>add</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>

  </div>

  <div *ngIf="!preinscriptions.length && readOnly">
    <h2 style="text-align: center;">Vous n'avez pas de préinscription.</h2>
  </div>
</div>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>